/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FilterableMultiSelect } from '@carbon/react';
import { useTranslation } from '../../../../Utilities/i18n/i18n.js';
import _translateWithId from '../../EnhancedDataTable/misc/translation.js';

var _excluded = ["columnKey", "onChange", "mode"];

/* eslint-disable react/prop-types */

var hoc = function hoc(WrappedComponent) {
  return function (_ref) {
    var columnKey = _ref.columnKey,
      onChange = _ref.onChange,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'live' : _ref$mode,
      passthroughProps = _objectWithoutProperties(_ref, _excluded);
    var augmentedOnChange = function augmentedOnChange(args) {
      onChange(_objectSpread2(_objectSpread2({}, args), {}, {
        columnKey: columnKey,
        mode: mode
      }));
    };
    var _useTranslation = useTranslation(),
      t = _useTranslation.t;
    return /*#__PURE__*/React.createElement(WrappedComponent
    // eslint-disable-next-line react/jsx-props-no-spreading
    , _extends({}, passthroughProps, {
      columnKey: columnKey,
      translateWithId: function translateWithId(id) {
        return _translateWithId(id, t);
      },
      onChange: augmentedOnChange,
      useTitleInItem: true
    }));
  };
};
var TableToolbarMultiSelect = hoc(FilterableMultiSelect);
var TableToolbarMultiSelect$1 = TableToolbarMultiSelect;

export { TableToolbarMultiSelect$1 as default };
